$primary-color: #7fb02f;

.tr {
	border-bottom: 1px solid #f3f4f6;
	transition: background-color 0.2s ease;
}

.tr:nth-child(4n + 1),
.tr:nth-child(4n + 2) {
	background: #f9fafb;
}

.tr:hover {
	background: #fafafa;
}

.trClickable {
	cursor: pointer;
}

.trExpanded {
	background: rgba(127, 176, 47, 0.08) !important;
}

.trExpanded:hover {
	background: rgba(127, 176, 47, 0.12) !important;
}

.td {
	padding: 0.6rem 0.75rem;
	vertical-align: top;
	color: #111827;
	white-space: normal;
	overflow: visible;
	text-overflow: clip;
	word-break: break-word;
	overflow-wrap: anywhere;
	hyphens: auto;
	position: relative;
}

.tdCompact {
	padding: 0.4rem 0.5rem;
	font-size: 0.8rem;
	line-height: 1.3;
}

.cellInner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	overflow: visible;
	text-overflow: clip;
	white-space: inherit;
}

.expandButton {
	background: none;
	border: none;
	padding: 0.25rem;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: #6b7280;
	transition: all 0.2s ease;
	border-radius: 0.25rem;
	flex-shrink: 0;

	&:hover {
		background: rgba(0, 0, 0, 0.05);
		color: $primary-color;
	}

	&:active {
		transform: scale(0.95);
	}
}

.expandedRow {
	background: rgba(127, 176, 47, 0.04);
}
